import React from "react";
import { getCategoryColor } from "../lib/constants";

/**
 * Horizontal DNA bars. Used on cards and detail pages.
 * axes: [{ key, label, value }] OR pass dna object + axes list of keys
 */
export default function DnaBars({ axes = [], category = "classic", compact = false }) {
  const color = getCategoryColor(category);
  return (
    <ul className={`space-y-${compact ? 1 : 2} w-full`} data-testid="dna-bars">
      {axes.map((a, i) => (
        <li key={a.key} className="flex items-center gap-3">
          <span className={`${compact ? "text-[10px]" : "text-xs"} uppercase tracking-[0.2em] text-white/60 w-20 shrink-0`}>
            {a.label}
          </span>
          <span className="relative flex-1 h-[3px] bg-white/8 overflow-hidden">
            <span
              className="dna-fill absolute left-0 top-0 bottom-0"
              style={{
                width: `${(a.value / 5) * 100}%`,
                background: color,
                animationDelay: `${i * 70}ms`,
                boxShadow: `0 0 8px ${color}55`,
              }}
            />
          </span>
          <span className={`${compact ? "text-[10px]" : "text-xs"} text-white/40 w-4 text-right tabular-nums`}>
            {a.value}
          </span>
        </li>
      ))}
    </ul>
  );
}
